function Hero(){
    
    return (
      <div className="ml-[12px] desktop:mt-2 desktop:ml-[28px]  tablet:ml-[20px] z-10">
        <div className="">
          <div
            className="pointer-events-none font-murmure opacity-[.13] fixed top-[70px] 
          desktop:top-[96px] text-aboutmob desktop:text-interviews tablet:mt-[20px] tablet:text-[200px] desktop:z-10"
          >
            <h1 className="desktop:text-[34vw] tablet:text-[30vw] text-[32vw] leading-none">
              INTERVIEWS
            </h1>
          </div>
        </div>

        {/* <div className="h-8 tablet:h-[270px] desktop:h-[420px] relative inline-block"></div> */}
        <div className="tablet:hidden h-[70px]"></div>
        <div className="inline-block h-0 tablet:pb-[40%] pb-[33%] w-[95%] tablet:w-[80%]"></div>

        <div className="desktop:flex z-40 desktop:gap-x-[64px]">
          <div className="mt-5 ml-[5px] font-apfelgrotezk desktop:mt-[40px] tablet:mt-[60px] desktop:w-4/6">
            <p className="text-paboutmob w-[87vw] desktop:text-[3vw] desktop:leading-none xl:text-pabout desktop:min-w-fit desktop:max-w-[825px] tablet:text-paboutt tablet:w-[480px] desktop:mr-5 ">
              SIAT students + alumni are invited to apply to interview with three
              of seven design agencies + product companies{" "}
              {/* <br className="desktop:hidden" /> */}
              at Touchpoint. Interviews will be held remotely between March
              16-30, 2023.
            </p>
            <p
              className=" mt-[9px] text-xs
                        xl:text-[xl] desktop:text-[2vw] desktop:mt-[30px] 
                        tablet:text-base tablet:mt-4 "
            >
              **Applications close March 15th at 5:00pm
            </p>
          </div>
          <a
            href="https://forms.gle/bw16gamVcX71vbAD7"
            target="_blank"
            className="font-apfelgrotezk border tablet:border-[1.5px] border-[#311500] border-opacity-80 bg-strawberry text-[25px] mt-[12px] pl-[9px] pr-[17px] py-[3px]
                                desktop:text-[3vw] desktop:leading-tight desktop:w-1/3 desktop:flex desktop:items-center desktop:justify-center desktop:h-[110px] 
                                desktop:mt-[60px] desktop:ml-auto desktop:mr-[50px] text-center desktop:px-[22px] inline-block
                                 hover:bg-chocolate hover:text-strawberry transition-all duration-300"
          >
            APPLY NOW <span className="desktop:text-[4rem]">&nbsp;&rarr;</span>
          </a>
        </div>
      </div>
    );
}

export default Hero;